import { render, staticRenderFns } from "./item-img.vue?vue&type=template&id=447402f0&scoped=true"
import script from "./item-img.vue?vue&type=script&lang=js"
export * from "./item-img.vue?vue&type=script&lang=js"
import style0 from "./item-img.vue?vue&type=style&index=0&id=447402f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447402f0",
  null
  
)

export default component.exports